import React, {Component} from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import emptycart from "../../../assets/img/icons/empty-cart.svg";
import {decrementToCart, incrementToCart, removeItemFromCart,} from "../../../redux/actions/Cart.Action";
import CartProductView from "./CartProductView";

class CurrentCartData extends Component {
  constructor() {
    super();
    this.state = { viewModal: false, product: false };
  }
  closeView = () => {
    this.setState({ viewModal: false, product: false });
  };
  render() {
    const CurrentCart = this.props.CurrentCart;
    const OrdersList = this.props.CurrentCartOrder; 
    return (
      <React.Fragment> 
        {OrdersList && OrdersList.length !== 0 ? (
          <table className="table table-borderless table-responsive">
            <thead>
              <tr className="d-flex col-12">
                <th className="col-7">
                  Items {OrdersList ? `(` + OrdersList.length + `)` : ""}{" "}
                  {CurrentCart ? CurrentCart.ordertime : ""}
                </th>
                <th className="col">Qty</th>
                <th className="col">Total</th>
                {this.props.POS ? <th className="col"></th> : ""}
              </tr>
            </thead>
            <tbody>
              {OrdersList.map((order, index) => (
                <tr className="d-flex col-12" key={index}>
                  <td
                    className="col-7"
                    onClick={() =>
                      this.setState({ viewModal: true, product: order })
                    }
                  >
                    <div className="d-flex gap-items text-truncate ml-10">
                      <LazyLoadImage
                        className="avatar"
                        delayTime="500"
                        placeholder={
                          <span className="material-icons-outlined">
                            hourglass_top
                          </span>
                        }
                        src={order.image}
                        alt={order.name}
                      />
                      <div className="media-body">
                        <h6>{order.name}</h6>
                        <span>
                          Rs.{order.price}
                          {parseInt(order.orderplace) ? (
                            <span className="fs-16 material-icons-outlined text-warning">
                              delivery_dining
                            </span>
                          ) : (
                            <span className="fs-16 material-icons-outlined text-success">
                              dining
                            </span>
                          )}{" "}
                          {order.prdnote}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td className="col">
                    <div className="btn-group btn-group-xs">
                      <span
                        style={{
                          display: !this.props.LockScreen ? "block" : "none",
                        }}
                        onClick={() =>
                          this.props.decrementToCart(
                            order.prodid,
                            order.prdnote,
                            order.orderplace
                          )
                        }
                        className="material-icons-outlined text-danger"
                      >
                        remove_circle_outline
                      </span>
                      <span className="px-10">{order.qty}</span>
                      <span
                        style={{
                          display: !this.props.LockScreen ? "block" : "none",
                        }}
                        onClick={() =>
                          this.props.incrementToCart(
                            order.prodid,
                            order.prdnote,
                            order.orderplace
                          )
                        }
                        className="material-icons-outlined text-success"
                      >
                        add_circle_outline
                      </span>
                    </div>
                  </td>
                  <td className="col text-center">{order.qty * order.price}</td>
                  {this.props.POS ? (
                    <td
                      className="col text-center hover-danger"
                      onClick={() =>
                        this.props.removeItemFromCart(
                          order.prodid,
                          order.prdnote,
                          order.orderplace
                        )
                      }
                    >
                      <span className="material-icons-outlined">
                        delete_forever
                      </span>
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-center py-50">
            <LazyLoadImage src={emptycart} alt="emptyCarticon" width="200" />
            <h4 className="text-danger">Your Cart is Empty!</h4>
          </div>
        )}
        <CartProductView
          trigger={this.state.viewModal}
          hideTrigger={this.closeView}
          product={this.state.product}
        />
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => ({
    CurrentCart: state.Cart.CurrentCart,
    CurrentCartOrder: state.Cart.CurrentCart.order,
    OldCart: state.Cart.OldCart,
    LockScreen: state.Auth.lockScreen,
  }),
  {
    incrementToCart,
    decrementToCart,
    removeItemFromCart,
  }
)(withRouter(React.memo(CurrentCartData)));
